import { writable } from "svelte/store";
import { captureEvent } from "#lib/utils/posthog.js";

// Controls the €10-off survey signup popup. The header promo bar, the footer
// button and the product-page line set it true; the modal (rendered once in
// +layout.svelte) reads it.
export const signup10Open = writable(false);

// Which entry point opened it: "topbar", "footer" or "pdp_line". The survey
// events carry it, so the entry points can be told apart; they all said
// "survey_modal" before (hub ledger 2026-10-01-092). "buy_box" is the
// seasonal offer button beside Order now.
export const signup10Source = writable("topbar");

/** Open the survey from an entry point and record the click. */
export function openSignup10(source) {
  captureEvent("topbar_10off_clicked", { source });
  signup10Source.set(source);
  signup10Open.set(true);
}
